<template>
  <v-card class="d-flex flex-column flex" style="height: 100%">
    <v-card-title class="d-flex align-center">
      <v-btn icon class="mr-3" @click="$emit('back')">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <span>{{ timetable ? timetable.name : 'Timetable' }}</span>
    </v-card-title>
    <v-card-subtitle>
      <div class="d-flex justify-between px-4">
        <div>
          <div>
            {{ timetable.programme ? timetable.programme.name : '' }} {{ timetable.semester ? timetable.semester.title :
            '' }} - Schedule
          </div>
          <div class="d-flex align-center">
            <span>Today is {{ getCurrentDate() }}</span>
            <v-btn class="ml-2" small icon color="primary" title="Print Timetable" @click="printTimetable">
              <v-icon>mdi-printer</v-icon>
            </v-btn>
          </div>
        </div>
        <div class="ml-auto" v-if="!isStudent">
          <v-btn depressed color="primary" @click="isCreateTableItem = true">Create Timetable Item</v-btn>
        </div>
      </div>
    </v-card-subtitle>
    <v-card-text>
      <div class="timetable-container">
        <div class="timetable-grid">
          <!-- Days columns -->
          <div v-for="(day, index) in days" :key="'day-'+index" class="day-column">
            <!-- Day header -->
            <div class="day-header">
              <v-card 
                class="text-center py-3 white--text" 
                :class="{
                  'red': isTodayDay(day.name),
                  'amber darken-2': isNextDay(day.name),
                  'primary': !isTodayDay(day.name) && !isNextDay(day.name)
                }" 
                elevation="3" 
                tile
              >
                <div class="text-h6 font-weight-medium">{{ day.name }}</div>
                <div class="text-caption">{{ formatDayDate(index) }}</div>
              </v-card>
            </div>

            <!-- Course slots for this day -->
            <div v-for="n in 5" :key="'course-'+index+'-'+n" class="course-slot">
              <v-hover v-slot="{ hover }">
                <v-card v-if="getCourseForSlot(day.name, n)" :elevation="hover ? 4 : 1" :class="{'on-hover': hover}"
                  class="course-card">
                  <div class="course-content">
                    <div class="d-flex justify-space-between align-center">
                      <div class="font-weight-bold primary--text">{{ getCourseForSlot(day.name, n).title || 'COURSE CODE' }}</div>
                      <div v-if="hover && !isStudent" class="d-flex">
                        <v-btn icon x-small color="primary" class="edit-btn mr-1" @click.stop="editTimetableItem(getCourseForSlot(day.name, n))">
                          <v-icon small>mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn icon x-small color="error" class="delete-btn" @click.stop="confirmDeleteItem(getCourseForSlot(day.name, n))">
                          <v-icon small>mdi-delete</v-icon>
                        </v-btn>
                      </div>
                    </div>
                    <div class="course-name">{{ getCourseForSlot(day.name, n).title || 'Course Name' }}</div>
                    <div class="d-flex align-center mt-1">
                      <v-icon small class="mr-1">mdi-clock-outline</v-icon>
                      <span class="time-range">{{ formatTimeRange(getCourseForSlot(day.name, n)) }}</span>
                    </div>
                    <div class="d-flex align-center mt-1" v-if="getCourseForSlot(day.name, n).lecturer">
                      <v-icon small class="mr-1">mdi-account</v-icon>
                      <span class="lecturer">{{ getCourseForSlot(day.name, n).lecturer }}</span>
                    </div>
                    <div class="d-flex align-center mt-1" v-if="getCourseForSlot(day.name, n).venue">
                      <v-icon small class="mr-1">mdi-map-marker</v-icon>
                      <span class="venue">{{ getCourseForSlot(day.name, n).venue }}</span>
                    </div>
                  </div>
                </v-card>
                <div v-else class="empty-slot"></div>
              </v-hover>
            </div>
          </div>
        </div>
      </div>
    </v-card-text>

    <!-- Add timetable item -->
    <div>
      <v-dialog v-model="isCreateTableItem" width="600px">
        <v-card>
          <v-card-title class="d-flex">
            {{ editMode ? 'Edit' : 'Add' }} Time Table Item

            <v-btn class="ml-auto" depressed text color="error" @click="isCreateTableItem = false; editMode = false; tbItemObj = {}">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>


          <v-card-text>
            <!-- Title of the table item-->
            <v-text-field dense placeholder="Enter Name" outlined v-model="tbItemObj.title" />

            <!-- days of the week-->
            <v-select dense outlined placeholder="Day" :items="days" v-model="tbItemObj.day" item-text="name" />

            <!-- select date -->
            <!-- <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
              offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="tbItemObj.date" dense label="Select Start Date" prepend-inner-icon="mdi-calendar"
                  readonly outlined v-bind="attrs" v-on="on"></v-text-field>
              </template>
              <v-date-picker v-model="tbItemObj.date" @input="menu = false"></v-date-picker>
            </v-menu> -->


            <!-- start Time -->
            <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" :nudge-right="40"
              :return-value.sync="tbItemObj.startTime" transition="scale-transition" offset-y max-width="290px"
              min-width="290px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="tbItemObj.startTime" label="Start Time"
                  prepend-inner-icon="mdi-clock-time-four-outline" outlined dense readonly v-bind="attrs"
                  v-on="on"></v-text-field>
              </template>
              <v-time-picker v-if="menu2" v-model="tbItemObj.startTime" full-width
                @click:minute="$refs.menu2.save(tbItemObj.startTime)"></v-time-picker>
            </v-menu>


            <!-- stop Time -->
            <v-menu ref="menu3" v-model="menu3" :close-on-content-click="false" :nudge-right="40"
              :return-value.sync="tbItemObj.stopTime" transition="scale-transition" offset-y max-width="290px"
              min-width="290px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="tbItemObj.stopTime" label="Stop Time"
                  prepend-inner-icon="mdi-clock-time-four-outline" outlined dense readonly v-bind="attrs"
                  v-on="on"></v-text-field>
              </template>
              <v-time-picker v-if="menu3" v-model="tbItemObj.stopTime" full-width
                @click:minute="$refs.menu3.save(tbItemObj.stopTime)"></v-time-picker>
            </v-menu>

                      <!-- Venue -->
          <v-text-field
            dense
            placeholder="Enter Venue"
            outlined
            v-model="tbItemObj.venue"
          />
          </v-card-text>

          <v-card-actions>
            <v-btn depressed color="primary" style="width: 40%;" class="d-flex mx-auto" large @click="saveTimetableItem">
              {{ editMode ? 'Update' : 'Add' }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <!-- Delete confirmation dialog -->
    <v-dialog v-model="isDeleteDialogOpen" max-width="400">
      <v-card>
        <v-card-title class="headline">Delete Timetable Item</v-card-title>
        <v-card-text>
          Are you sure you want to delete this timetable item?
          <div v-if="itemToDelete" class="mt-2">
            <strong>{{ itemToDelete.title }}</strong>
            <div>{{ itemToDelete.day }} ({{ formatTimeRange(itemToDelete) }})</div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="isDeleteDialogOpen = false">Cancel</v-btn>
          <v-btn color="error" text @click="deleteTimetableItem">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <loading-dialog :show="loading"></loading-dialog>
  </v-card>
</template>

<script>
import Api from "@/main/api";
import ErrorResolver from "@/shared/ErrorResolver";
import LoadingDialog from "@ui/components/LoadingDialog";
import timeTable from "@/shared/apis/timetable/timetable";

export default {
  name: 'TimetableDetailsView',
  
  components: {
    LoadingDialog,
  },

  props: {
    timetable: {
      type: Object,
      required: true
    },
    isStudent: {
      type: Boolean,
      default: false
    }
  },
  
  data: () => ({
    days: [
      { name: 'MONDAY' },
      { name: 'TUESDAY' },
      { name: 'WEDNESDAY' },
      { name: 'THURSDAY' },
      { name: 'FRIDAY' },
      { name: 'SATURDAY' }
    ],
    menu: null,
    menu2: null,
    menu3: null,
    timetableItems: [],
    loading: false,
    error: null,
    isCreateTableItem: false,
    isDeleteDialogOpen: false,
    itemToDelete: null,
    tbItemObj: {
      title: '',
      selectedDay: null,
      date: null,
      startTime: null,
      stopTime: null,
      lecturer: '',
      venue: ''
    },
    
    // Dialog control
    showItemDialog: false,
    editMode: false,
    currentItemId: null,
    
    // Form data
    currentItem: {
      id: null,
      title: '',
      day: null,
      startTime: null,
      stopTime: null,
      lecturer: '',
      venue: '',
      timeTableId: null
    },
    
    // Time pickers
    startTimeMenu: false,
    endTimeMenu: false,
    formattedStartTime: null,
    formattedEndTime: null,
    
    // Message handling
    messageShow: false,
    message: '',
    messageType: 'success'
  }),
  
  methods: {
    printTimetable() {
      // Store current body styles
      const originalBodyStyle = document.body.style.cssText;
      
      // Create a new window for printing
      const printWindow = window.open('', '_blank');
      
      // Generate print content
      const content = `
        <html>
          <head>
            <title>${this.timetable ? this.timetable.name : 'Timetable'}</title>
            <style>
              body { font-family: Arial, sans-serif; }
              .timetable { width: 100%; border-collapse: collapse; margin-top: 20px; }
              .timetable th, .timetable td { 
                border: 1px solid #ddd; 
                padding: 8px; 
                text-align: left; 
              }
              .timetable th { 
                background-color: #1976D2; 
                color: white; 
              }
              .course-item { 
                margin: 5px 0; 
                padding: 8px; 
                background-color: #f5f5f5; 
                border-radius: 4px; 
              }
              .header { 
                text-align: center; 
                margin-bottom: 20px; 
              }
              @media print {
                .timetable { page-break-inside: avoid; }
              }
            </style>
          </head>
          <body>
            <div class="header">
              <h2>${this.timetable ? this.timetable.name : 'Timetable'}</h2>
              <p>${this.timetable.programme ? this.timetable.programme.name : ''} ${this.timetable.semester ? this.timetable.semester.title : ''} - Schedule</p>
              <p>Generated on ${this.getCurrentDate()}</p>
            </div>
            <table class="timetable">
              <thead>
                <tr>
                  <th>Day</th>
                  <th>Courses</th>
                </tr>
              </thead>
              <tbody>
                ${this.days.map(day => `
                  <tr>
                    <td>
                      <strong>${day.name}</strong><br>
                    </td>
                    <td>
                      ${Array.from({length: 5}, (_, i) => i + 1)
                        .map(slot => this.getCourseForSlot(day.name, slot))
                        .filter(course => course)
                        .map(course => `
                          <div class="course-item">
                            <strong>${course.title}</strong><br>
                            Time: ${this.formatTimeRange(course)}<br>
                            ${course.lecturer ? `Lecturer: ${course.lecturer}<br>` : ''}
                            ${course.venue ? `Venue: ${course.venue}` : ''}
                          </div>
                        `).join('')}
                    </td>
                  </tr>
                `).join('')}
              </tbody>
            </table>
          </body>
        </html>
      `;

      // Write content to the new window
      printWindow.document.write(content);
      printWindow.document.close();

      // Wait for content to load then print
      printWindow.onload = function() {
        printWindow.print();
        printWindow.onafterprint = function() {
          printWindow.close();
          // Restore original body styles
          document.body.style.cssText = originalBodyStyle;
        };
      };
    },
    // Timetable Item CRUD Operations
    addTimetableItem(day = null) {
      this.editMode = false;
      this.resetForm();
      this.currentItemId = null;
      
      // If a day was provided, pre-select it
      if (day) {
        this.tbItemObj.day = day;
      }
      
      // Set the timetable ID
      this.tbItemObj.timeTableId = this.timetable.id;
      
      this.isCreateTableItem = true;
    },
    
    editTimetableItem(item) {
      if (!item) return;
      
      this.editMode = true;
      this.resetForm();
      
      // Store the item ID for the update operation
      this.currentItemId = item.id;
      
      // Populate the form with the item data
      this.tbItemObj = {
        title: item.title || '',
        day: item.day || null,
        date: item.date || null,
        lecturer: item.lecturer || '',
        venue: item.venue || '',
        timeTableId: this.timetable.id
      };
      
      // Format times for the time pickers
      if (item.startTime && Array.isArray(item.startTime) && item.startTime.length >= 2) {
        this.tbItemObj.startTime = `${item.startTime[0].toString().padStart(2, '0')}:${item.startTime[1].toString().padStart(2, '0')}`;
      }
      
      if (item.stopTime && Array.isArray(item.stopTime) && item.stopTime.length >= 2) {
        this.tbItemObj.stopTime = `${item.stopTime[0].toString().padStart(2, '0')}:${item.stopTime[1].toString().padStart(2, '0')}`;
      }
      
      this.isCreateTableItem = true;
    },
    
    resetForm() {
      this.tbItemObj = {
        title: '',
        day: null,
        date: null,
        startTime: '08:00',
        stopTime: '10:00',
        lecturer: '',
        venue: '',
        timeTableId: this.timetable ? this.timetable.id : null
      };
      
      this.formattedStartTime = '08:00';
      this.formattedEndTime = '10:00';
    },
    
    saveTimetableItem() {
      this.loading = true;

      this.tbItemObj.timeTableId = this.timetable.id;
      this.tbItemObj.startTime = this.convertTimeToDateTime(this.tbItemObj.startTime);
      this.tbItemObj.stopTime = this.convertTimeToDateTime(this.tbItemObj.stopTime);

      const apiCall = this.editMode && this.currentItemId
        ? Api.timetable.updateTimetableItem(this.currentItemId, this.tbItemObj)
        : Api.timetable.createTimetableItem(this.tbItemObj);

      apiCall
        .then(() => {
          this.$notify({
            type: 'success',
            message: `Time Table Item ${this.editMode ? 'updated' : 'created'} for ${this.timetable.name} was successful`
          });
          this.isCreateTableItem = false;
          this.loadTimetableItems(); // Reload items to reflect changes
        })
        .catch((error) => ErrorResolver.checkErrors(this, error))
        .finally(() => {
          this.loading = false;
        })
    },
    
    confirmDeleteItem(item) {
      this.itemToDelete = item;
      this.isDeleteDialogOpen = true;
    },
    
    deleteTimetableItem() {
      if (!this.itemToDelete || !this.itemToDelete.id) {
        this.$notify({
          type: 'error',
          message: 'Invalid timetable item'
        });
        return;
      }
      
      this.loading = true;
      
      Api.timetable.deleteTimetableitem(this.itemToDelete.id)
        .then(() => {
          this.$notify({
            type: 'success',
            message: `Timetable item deleted successfully`
          });
          this.loadTimetableItems(); // Reload items to reflect changes
          this.isDeleteDialogOpen = false;
          this.itemToDelete = null;
        })
        .catch((error) => ErrorResolver.checkErrors(this, error))
        .finally(() => {
          this.loading = false;
        });
    },
    
    showMessage(message, type = 'success') {
      this.message = message;
      this.messageType = type;
      this.messageShow = true;
    },
    
    // Existing methods
    getCurrentDate() {
      const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      const now = new Date();
      return `${days[now.getDay()]}, ${now.getDate()} ${months[now.getMonth()]} ${now.getFullYear()}`;
    },
    
    isTodayDay(dayName) {
      const today = new Date();
      const dayIndex = today.getDay(); // 0 = Sunday, 1 = Monday, etc.
      const dayNames = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];
      const todayName = dayNames[dayIndex];
      
      return dayName === todayName;
    },
    
    isNextDay(dayName) {
      const today = new Date();
      const dayIndex = today.getDay(); // 0 = Sunday, 1 = Monday, etc.
      const dayNames = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];
      
      // Calculate the next day index (wrapping around to 0 if today is Saturday)
      const nextDayIndex = (dayIndex + 1) % 7;
      const nextDayName = dayNames[nextDayIndex];
      
      return dayName === nextDayName;
    },

    convertTimeToDateTime(time) {
            const currentDate = new Date();
            const [hours, minutes] = time.split(':');

            // Create a new Date object with the selected time
            const dateTime = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), hours, minutes);

            // Format the time as HH:mm:ss
            const formattedTime = `${dateTime.getHours().toString().padStart(2, '0')}:${dateTime.getMinutes().toString().padStart(2, '0')}:${dateTime.getSeconds().toString().padStart(2, '0')}`;

            // console.log('Converted Time:', formattedTime); 

            return formattedTime; // Return the formatted time string
        },
    
    formatDayDate(dayOffset) {
      const now = new Date();
      const date = new Date(now);
      // Adjust to get the date for the current week starting from Monday
      const currentDay = now.getDay(); // 0 = Sunday, 1 = Monday, ...
      const daysToAdd = dayOffset - (currentDay - 1);
      date.setDate(now.getDate() + daysToAdd);
      
      return `${date.getDate()} ${this.getMonthShort(date.getMonth())}`;
    },
    
    getMonthShort(monthIndex) {
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      return months[monthIndex];
    },
    
    // Method kept for internal time slot references but no longer displayed in UI
    getTimeSlot(slotNumber) {
      const startTimes = ['8:00 AM', '10:00 AM', '12:00 PM', '2:00 PM', '4:00 PM'];
      const endTimes = ['10:00 AM', '12:00 PM', '2:00 PM', '4:00 PM', '6:00 PM'];
      return `${startTimes[slotNumber-1]} - ${endTimes[slotNumber-1]}`;
    },
    
    loadTimetableItems() {
      console.log(this.timetable)
      if (!this.timetable || !this.timetable.id) return;
      
      this.loading = true;
      this.error = null;
      
      Api.timetable.getTimeTableItems(this.timetable.id)
        .then(response => {
          this.timetableItems = response.data || [];
          console.log('Timetable items loaded:', this.timetableItems);
          
          // Debug Tuesday data specifically
          console.log('TUESDAY data:', this.timetableItems.TUESDAY || 'No TUESDAY data');
          if (this.timetableItems.TUESDAY) {
            console.log('Number of TUESDAY items:', this.timetableItems.TUESDAY.length);
            this.timetableItems.TUESDAY.forEach((item, index) => {
              console.log(`TUESDAY item ${index}:`, item);
            });
          }
        })
        .catch(error => {
          this.error = 'Failed to load timetable items';
          ErrorResolver.checkErrors(this, error);
          console.error('Error loading timetable items:', error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    
    getCourseForSlot(day, slotNumber) {
      // Check if we have data for this day
      if (!this.timetableItems || !this.timetableItems[day]) {
        return null;
      }
      
      // Get all courses for this day
      const coursesForDay = this.timetableItems[day] || [];
      
      // If there are no courses for this day, return null
      if (coursesForDay.length === 0) {
        return null;
      }
      
      // Simple approach: just return the course at the index corresponding to the slot number
      // If the slot number is greater than the number of courses, return null
      if (slotNumber <= coursesForDay.length) {
        return coursesForDay[slotNumber - 1];
      }
      
      return null;
    },
    
    // This method is no longer used since we're not doing time range comparison
    timeInRange(itemStart, itemEnd, slotStart, slotEnd) {
      // Method kept for reference but no longer used
      return true;
    },
    
    formatTimeRange(item) {
      if (!item || !item.startTime || !item.stopTime) return this.getTimeSlot(1); // Default fallback
      
      // Convert time array [hours, minutes] to 12-hour format with AM/PM
      const format12Hour = (timeArray) => {
        if (!timeArray || !Array.isArray(timeArray) || timeArray.length < 2) return '';
        const hours = timeArray[0];
        const minutes = timeArray[1];
        const period = hours >= 12 ? 'PM' : 'AM';
        const hours12 = hours % 12 || 12; // Convert 0 to 12 for 12 AM
        return `${hours12}:${minutes.toString().padStart(2, '0')} ${period}`;
      };
      
      return `${format12Hour(item.startTime)} - ${format12Hour(item.stopTime)}`;
    }
  },
  
  watch: {
    timetable: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.id) {
          this.loadTimetableItems();
        } else {
          this.timetableItems = [];
        }
      }
    }
  }
}
</script>

<style scoped>
.timetable-container {
  padding: 8px;
  background-color: #f5f5f5;
  border-radius: 8px;
  overflow: hidden;
}

.timetable-grid {
  display: flex;
  width: 100%;
  overflow-x: auto;
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

/* Time styling - kept for reference but elements removed from UI */
.time-label {
  font-size: 0.85rem;
  color: #757575;
  text-align: center;
  font-weight: 500;
}

/* Day column styling */
.day-column {
  flex: 1;
  min-width: 180px;
  border-right: 1px solid #e0e0e0;
}

.day-column:last-child {
  border-right: none;
}

.day-header {
  height: 76px;
  border-bottom: 1px solid #e0e0e0;
}

/* Course slot styling */
.course-slot {
  height: 150px;
  border-bottom: 1px solid #e0e0e0;
  padding: 8px;
}

.course-card {
  height: 100%;
  transition: all 0.3s;
  border-left: 4px solid var(--v-primary-base);
}

.course-card.on-hover {
  background-color: #f9f9f9;
}

.course-content {
  padding: 12px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.course-name {
  font-size: 0.9rem;
  margin-top: 4px;
  font-weight: 500;
}

.time-range, .lecturer {
  font-size: 0.8rem;
  color: #757575;
}

.edit-btn {
  opacity: 0.8;
}

.empty-slot {
  height: 100%;
  border: 1px dashed #e0e0e0;
  border-radius: 4px;
  background-color: #fafafa;
}

.venue {
  font-size: 0.8rem;
  color: #757575;
}

/* Loading overlay */
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .day-column {
    min-width: 150px;
  }
  
  .course-slot {
    height: 120px;
  }
}
</style>
